import { fetchMortgageBrokerPage } from 'api/directory';
import { wrapper } from 'store';
import TopicPage from 'components/Directory/TopicPage';
import TownPage from 'components/Directory/TownPage';
import {
    DIRECTORY_REVALIDATE,
    isDirectorySlug,
    isPageOfKind,
} from 'utils/directory';
import { notFound, notFoundOrThrow } from 'utils/isr';

// A town page when a town page has this slug, otherwise the topic (the API
// decides, see resolvePage); a topic it displaces lives under /topic/[slug].
const MortgageBrokerPage = ({ page }) => {
    if (page.kind === 'town') return <TownPage page={page} />;
    if (page.kind === 'topic') return <TopicPage page={page} />;
    return null;
};

export const getStaticPaths = () => ({ paths: [], fallback: 'blocking' });

export const getStaticProps = wrapper.getStaticProps(
    () =>
        async ({ params }) => {
            if (!isDirectorySlug(params.slug)) {
                return notFound();
            }
            try {
                const page = await fetchMortgageBrokerPage(params.slug);
                if (!isPageOfKind(page, ['town', 'topic'])) {
                    return notFound();
                }
                return { props: { page }, revalidate: DIRECTORY_REVALIDATE };
            } catch (err) {
                return notFoundOrThrow(err);
            }
        }
);

// No wrapper.withRedux: _app.js already provides the store.
export default MortgageBrokerPage;
